module.exports = __webpack_public_path__ + "img/icon-coupon-black.aae333f4.svg";